import { Home, Plane, Users, User, type LucideIcon } from "lucide-react";

export interface NavItem {
  icon: LucideIcon;
  labelKey: string;
  path: string;
}

export const navItems: NavItem[] = [
  { icon: Home, labelKey: "nav.home", path: "/" },
  { icon: Plane, labelKey: "nav.trips", path: "/trips" },
  { icon: Users, labelKey: "nav.groups", path: "/groups" },
  { icon: User, labelKey: "nav.profile", path: "/profile" },
];
